export default "__VITE_ASSET__be2954a8__"